<div class="modal-header">
  <div class="modal-title">
    <mat-icon class="info-icon">info</mat-icon>
    <span class="title-text">{{ 'supplierGuideModal.title' | translate }}</span>
  </div>
</div>

<div mat-dialog-content class="modal-body">
  <p class="intro-text">
    <strong>{{ 'supplierGuideModal.introText' | translate }}</strong>
  </p>

  <p>
    <strong>{{ 'supplierGuideModal.processSteps' | translate }}</strong>
  </p>

  <p class="section-title">
    <strong>{{ 'supplierGuideModal.step1Title' | translate }}</strong>
  </p>
  <p>
    * {{ 'supplierGuideModal.step1Text' | translate }} <strong>{{ 'supplierGuideModal.step1HasHistory' | translate }}</strong> {{ 'supplierGuideModal.step1TextContinue' | translate }} <strong>{{ 'supplierGuideModal.step1HistoricalSupplier' | translate }}</strong>.
  </p>

  <p class="section-title">
    <strong>{{ 'supplierGuideModal.step2Title' | translate }}</strong>
  </p>
  <p class="no-margin">{{ 'supplierGuideModal.step2Intro' | translate }}</p>
  <p>
    * {{ 'supplierGuideModal.step2Item1' | translate }}<br>
    * {{ 'supplierGuideModal.step2Item2' | translate }}<br>
    * {{ 'supplierGuideModal.step2Item3' | translate }}
  </p>

  <p class="section-title">
    <strong>{{ 'supplierGuideModal.step3Title' | translate }}</strong>
  </p>
  <p class="bottom-spacing">{{ 'supplierGuideModal.step3Text' | translate }}</p>

  <p>
    <strong>{{ 'supplierGuideModal.distributionQuestion' | translate }}</strong>
  </p>
  <p>{{ 'supplierGuideModal.distributionIntro' | translate }}</p>
  <ul>
    <li>
      <strong>{{ 'supplierGuideModal.beefMeat' | translate }}</strong>: {{ 'supplierGuideModal.beefDistribution' | translate }} <strong>{{ 'supplierGuideModal.historical' | translate }}</strong> {{ 'supplierGuideModal.and' | translate }} <strong>{{ 'supplierGuideModal.new' | translate }}</strong> {{ 'supplierGuideModal.suppliers' | translate }}
    </li>
    <li>
      <strong>{{ 'supplierGuideModal.porkChickenMeat' | translate }}</strong>: {{ 'supplierGuideModal.porkChickenDistribution' | translate }} <strong>{{ 'supplierGuideModal.historical' | translate }}</strong> {{ 'supplierGuideModal.and' | translate }} <strong>{{ 'supplierGuideModal.new' | translate }}</strong> {{ 'supplierGuideModal.suppliers' | translate }}
    </li>
  </ul>

  <p class="important-note">
    <strong>{{ 'supplierGuideModal.mainRule' | translate }}</strong> {{ 'supplierGuideModal.mainRuleText' | translate }} <strong>{{ 'supplierGuideModal.use' | translate }}</strong> {{ 'supplierGuideModal.mainRuleTextContinue' | translate }}
  </p>

  <hr class="divider">
  <p class="reference">
    <strong>{{ 'supplierGuideModal.governmentResolution' | translate }}</strong><br>
    <a
      href="https://cbd.minjust.gov.kg/51-365/edition/873708/ru"
      target="_blank"
      rel="noopener noreferrer"
    >
      https://cbd.minjust.gov.kg/51-365/edition/873708/ru
    </a>
  </p>
</div>
